import React from "react";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import { TableRow } from "@material-ui/core";

export default function CustomTableFooter({
  rowsLength,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
}) {
  return (
    <TableFooter>
      <TableRow>
        <TablePagination
          labelRowsPerPage={"Resultados por página"}
          count={rowsLength}
          rowsPerPage={rowsPerPage}
          page={page}
          component="td"
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      </TableRow>
    </TableFooter>
  );
}
